import React, { useEffect } from "react";
import { Heading } from "../../../../subComponents/Heading";
import AOS from "aos";
import "aos/dist/aos.css";
import { Img } from "../../../../subComponents/img";

const VisionCard = ({ title,imgUrl }) => {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <>
      <div className="vision_card shadow" data-aos="fade-left">
        {/* <Heading title={title} /> */}
        <Img src={imgUrl} alt={title} />
      </div>
    </>
  );
};
export { VisionCard };
